// extracted by mini-css-extract-plugin
export var mobileMenu = "MobileMenu-module--mobileMenu--7881f";
export var container = "MobileMenu-module--container--20f94";